import { createTheme, Theme, ThemeOptions, Palette, IThemeOptions, ITheme } from "@mui/material";

declare module '@mui/material/styles' {
    interface IPalette extends Palette {
        leo: {
            primary: {
                blue: {
                    25: string;
                    50: string;
                    100: string;
                    200: string;
                    300: string;
                    400: string;
                    500: string;
                    600: string;
                    700: string;
                    800: string;
                    900: string;
                }
            }
            type:{
                25: string;
                200: string;
                300: string;
                400: string;
                600: string;
                900: string;
            }
            header: {
                background: string;
            }
            semantic: {
                green: string;
                yellow: string;
                red: string;
            }
            color1: string;
            color2: string;
            color3: string;
            color4: string;
            color5: string;
            color6: string;
            color7: string;
            color8: string;
            color9: string;
            color10: string;
            color11: string;
            color12: string;
            color13: string;
            color14: string;
            color15: string;
            color16: string;
            color17: string;
            color18: string;
            color19: string;
            tone1: string;
            tone2: string;
            tone3: string;
            tone4: string;
            tone5: string;
            tone6: string;
            tone7: string;
            tone8: string;
            tone9: string;
            tone10: string;
            tone11: string;
            tone12: string;
            tone13: string;
            tone14: string;
            tone15: string;
        }
    }
    interface ITheme extends Theme {
        palette: IPalette;
    }
    interface IThemeOptions extends ThemeOptions {
        palette: IPalette;
    }
    // interface Theme {
    //     palette: {
    //         common: {
    //             tone1: string;
    //         };
    //     };
    // }
    // // allow configuration using `createTheme`
    // interface ThemeOptions {
    //     palette?: {

    //         common?: {
    //             tone1?: string;
    //         };
    //     };
    // }
}

let leotheme = createTheme({
    palette: {
        mode: 'light',
        background: {
            default: "#F2F5FA"
        },
        primary: {
            main: "#E5EBF6", //main: "#B3B3B3",
            light: "#F2F5FA",
            dark: "#164CAE",
            contrastText: "#FFFFFF"
        },
        secondary: {
            main: "#32D583"
        },
        info: {
            main: "#E5EBF6",
            contrastText: "#101828"
        },
        leo: {
            primary: {
                blue: {
                    25: "#F2F5FA",
                    50: "#E5EBF6",
                    100: "#B1C3E4",
                    200: "#7E9CD2",
                    300: "#4A74C0",
                    400: "#164CAE",
                    500: "#113B87",
                    600: "#0C2A61",
                    700: "#07193A",
                    800: "#020813",
                    900: "#000000"
                }
            },
            type:{
                25: "#FCFCFD",
                200: "#EAECF0",
                300: "#D0D5DD",
                400: "#98A2B3",
                600: "#475467",
                900: "#101828"
            },
            header: {
                background: "#ffffff"
            },
            semantic: {
                green: "#32D583",
                yellow: "#FDB022",
                red: "#F04438"
            },
            color1: "#FF7070",
            color2: "#EE5A47",
            color3: "#F8873D",
            color4: "#FFB77D",
            color5: "#F0E5C7",
            color6: "#FFE17D",
            color7: "#F9D33E",
            color8: "#96E3B0",
            color9: "#32ADA5",
            color10: "#ABE7FF",
            color11: "#6ACDEC",
            color12: "#DFCDF7",
            color13: "#B391E0",
            color14: "#BA69DE",
            color15: "#8760CF",
            color16: "#F8C6CF",
            color17: "#DF568E",
            color18: "#C4005F",
            color19: "#B7BFFD",
            //OLD COLORS
            tone1: "#828282",
            tone2: "#5A5A5A",
            tone3: "#757575",
            tone4: "#7A7A7A",
            tone5: "#626262",
            tone6: "#BFBFBF",
            tone7: "#7C62F6",
            tone8: "#1E1E1E",
            tone9: "#717171",
            tone10: "#A6A6A6",
            tone11: "#C0C0C0",
            tone12: "#E0E0E0",
            tone13: "#979797",
            tone14: "#4F4F4F",
            tone15: "#333333"
        },
        text: {
            primary: "#101828",
            secondary: "#98A2B3"
        }
    },
    typography: {
        fontFamily: "Montserrat",
        allVariants: {
            fontSize: "14px",
            lineHeight: "17.07px",
            color: "#101828"
        },

    },
    components: {
        MuiTextField: {
            defaultProps: {
                InputProps: {
                    sx: {
                        borderRadius: "8px"
                    }
                },
                inputProps: {
                    style: {
                        padding: "14.5px"
                    }
                },
                sx: {
                    width: "375px",
                    height: "46px",
                }
            }
        },
        MuiButton: {
            defaultProps: {
                sx: {
                    textTransform: "none",
                }
            }
        },
        MuiLink: {
            defaultProps: {
                color: "#4F4F4F",
                sx: {
                    textDecoration: "none"
                }
            }
        },
        MuiFormControlLabel: {
            defaultProps: {
                slotProps: {
                    typography: {
                        fontWeight: "600"
                    }
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    border: "none",
                    fontSize: "16px",
                    lineHeight: "19.5px",
                    fontWeight: "400",
                    padding: "8px"
                },
                head: {
                    fontSize: "12px",
                    lineHeight: "15.36px",
                    fontWeight: "400"
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    backgroundColor: "#ffffff",
                    fontSize: "14px",
                    boxShadow: "0px 2px 16px 0px #0000000F",

                }
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    backgroundColor: "#ffffff",
                    color: "#000000",
                    boxShadow: "0px 2px 16px 0px #0000000F",
                    borderWidth: 0
                }
            }
        }
    }
} as IThemeOptions) as ITheme;

leotheme = createTheme(leotheme, {
    components: {
        MuiTypography: {
            styleOverrides: {
                h1: {
                    fontSize: "40px",
                    lineHeight: "48.76px",
                    fontWeight: "600"
                },
                h2: {
                    fontSize: "22px",
                    fontWeight: "500",
                    lineHeight: "26.82px"
                },
                h3: {
                    fontSize: "20px",
                    fontWeight: "500",
                    lineHeight: "24.38px"
                }
            }
        },
        MuiCircularProgress: {
            defaultProps: {
                sx: {
                    color: leotheme.palette.primary.dark
                }
            }
        },
        MuiPaginationItem: {
            styleOverrides: {
                root: {
                    fontSize: "16px",
                    fontWeight: "400",
                    "&:hover": {
                        backgroundColor: leotheme.palette.primary.main,
                        color: leotheme.palette.text.primary,
                    },
                    "&.Mui-selected": {
                        backgroundColor: leotheme.palette.common.white,
                        color: leotheme.palette.text.primary,
                        boxShadow: "0px 2px 2px 0px #164CAE1A",
                        "&:hover": {
                            backgroundColor: leotheme.palette.primary.main,
                            color: leotheme.palette.text.primary,
                        },
                    }
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: leotheme.palette.background.paper,
                    color: leotheme.palette.leo.type[600],
                    fontSize: "12px",
                    lineHeight: "18px",
                    fontWeight: "400",
                    boxShadow: "0px 4px 6px -2px #10182808"
                },
                arrow: {
                    color: leotheme.palette.background.paper
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState }: any) => ({
                    ...(ownerState.variant === 'contained' &&
                        ownerState.color === 'primary' && {
                        backgroundColor: leotheme.palette.primary.dark,
                        boxShadow: "0px 1px 2px 0px #1018280D"
                    }),
                    ...(ownerState.variant === 'outlined' &&
                        ownerState.color === 'primary' && {
                        backgroundColor: leotheme.palette.primary.main,
                        color: leotheme.palette.primary.dark,
                        "&:hover": {
                            backgroundColor: leotheme.palette.primary.dark,
                            color: leotheme.palette.common.white,
                        }
                    }),
                    ...(ownerState.variant === 'text' &&
                        ownerState.color === 'primary' && {
                        color: leotheme.palette.primary.dark,
                        "&:hover": {
                            backgroundColor: leotheme.palette.primary.main,
                        }
                    }),
                    ...(ownerState.variant === 'contained' &&
                        ownerState.color === 'info' && {
                        fontSize: "14px",
                        lineHeight: "17px",
                        fontWeight: "400",
                        "&:hover": {
                            backgroundColor: leotheme.palette.primary.light,
                            boxShadow: "0px 1px 2px 0px #1018280D"
                        },
                        "&:Mui-focused":{
                            backgroundColor: leotheme.palette.primary.dark,
                        }
                    }),
                    ...(ownerState.variant === 'outlined' &&
                        ownerState.color === 'info' && {
                        fontSize: "14px",
                        lineHeight: "17px",
                        fontWeight: "400",
                        backgroundColor: leotheme.palette.common.white,
                        "&:hover": {
                            backgroundColor: leotheme.palette.primary.light,
                            boxShadow: "0px 1px 2px 0px #1018280D"
                        },
                        "&:Mui-focused":{
                            backgroundColor: leotheme.palette.primary.light,
                        }
                    }),
                }),
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    "&:hover": {
                        backgroundColor: leotheme.palette.primary.light,
                        color: leotheme.palette.text.primary
                    },
                    "&.Mui-selected": {
                        backgroundColor: leotheme.palette.primary.dark,
                        color: leotheme.palette.common.white,
                        "&:hover": {
                            backgroundColor: leotheme.palette.leo.primary.blue[500],
                            color: leotheme.palette.common.white
                        },
                    }
                }
            }
        },
        MuiFormLabel: {
            defaultProps: {
                sx: {
                    fontWeight: "600",
                    color: leotheme.palette.text.primary,
                    paddingBottom: "3px"
                }
            },
            styleOverrides: {
                root: {
                    "&.Mui-focused": {
                        color: leotheme.palette.text.primary
                    }
                }
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    "&.Mui-checked": {
                        color: leotheme.palette.primary.dark
                    }
                }
            }
        },
        MuiInputLabel: {
            defaultProps: {
                sx: {
                    "&.Mui-focused": {
                        color: leotheme.palette.text.primary
                    }
                },
            },
            styleOverrides: {
                root: {
                    color: leotheme.palette.text.primary,
                },
            }
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    "&.Mui-focused": {
                        color: leotheme.palette.text.primary
                    }
                }
            }
        },
        MuiAppBar: {
            defaultProps: {
                sx: {
                    backgroundColor: leotheme.palette.primary.light,
                    padding: "0 60px"
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    color: leotheme.palette.common.black
                },
                head: {
                    color: leotheme.palette.leo.tone13
                }
            }
        },
        MuiMenuItem: {
            styleOverrides:{
                root:{
                    "&:hover":{
                        backgroundColor: leotheme.palette.primary.light,
                    }
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                InputProps: {
                    sx: {
                        backgroundColor: leotheme.palette.common.white,
                    }
                },
            },
            styleOverrides:{
                root: {
                    ".MuiOutlinedInput-notchedOutline": {
                        borderColor: leotheme.palette.leo.primary.blue[100]
                    }
                }
            }
        }
    }
}) as ITheme;

export default leotheme;